export const initialAbility = [
  // Miscellaneous Privilege -- Do not delete this Privilege --
  {
    subject: 'Auth',
    action: 'read',
  },

  // Dashboard Privilege
  {
    subject: 'Dashboard',
    action: 'read',
  },

  // Users Privilege
  {
    subject: 'Users',
    action: 'view',
  },
  {
    subject: 'Users',
    action: 'create',
  },
  {
    subject: 'Users',
    action: 'edit',
  },
  {
    subject: 'Users',
    action: 'markAsActiveInActive',
  },
  {
    subject: 'Users',
    action: 'delete',
  },

  // Roles Privilege
  {
    subject: 'Roles',
    action: 'view',
  },
  {
    subject: 'Roles',
    action: 'create',
  }, // Add Button Level Privileges

  // Fops Privilege
  {
    subject: 'Fops',
    action: 'view',
  },
  {
    subject: 'AllFops',
    action: 'view',
  },

  // Companies Privilege
  {
    subject: 'Companies',
    action: 'view',
  },
  {
    subject: 'Merchants',
    action: 'view',
  },

  // Orders Privilege
  {
    subject: 'Orders',
    action: 'refund',
  },
  {
    subject: 'Orders',
    action: 'index',
  },
  {
    subject: 'Refunds',
    action: 'view',
  },
  {
    subject: 'Orders',
    action: 'read',
  },
  {
    subject: 'Orders',
    action: 'create',
  },
  {
    subject: 'Instructionsfop',
    action: 'view',
  },
  {
    subject: 'Orders',
    action: 'paylink',
  },
  {
    subject: 'PaymentLink',
    action: 'annonmous',
  },
  {
    subject: 'instructionspaylink',
    action: 'annonmous',
  },
]

export const _ = undefined
